module.exports = __webpack_public_path__ + "static/media/pla_clear_strew2.5169da59.png";